import Immutable from 'seamless-immutable';
import _ from 'lodash';

import RefData from '../../ref-data';
import { baseCollection, filter } from '../../common/collections';

import Model from './account-template-model.js';

function deserialize(accountTemplates = []) {
  return Immutable(_.map(accountTemplates, Model.deserialize));
}

function serialize(accountTemplates) {
  return _.map(accountTemplates, accountTemplate => Model.serialize(accountTemplate));
}

export default {
  ...baseCollection,
  create: deserialize,
  deserialize,
  serialize,
};
